import InitializeLayout from '@js/layout';

import PlaceManager from '@js/managers/placeManager';

InitializeLayout();

PlaceManager.initialize();
